globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.GeneralController = (function(superClass) {

  utils.extend(GeneralController, superClass);

  function GeneralController() {
    return GeneralController.__super__.constructor.apply(this, arguments);
  }

  $.extend(GeneralController.prototype, {
    init: function() {
      this._initPhones();
      this._initOnlineServicesToggle();

      if ($('[data-role="google-maps-address-section"]').length) {
        this._initAddress();
      }
      return GeneralController.__super__.init.apply(this, arguments);
    },

    _initOnlineServicesToggle: function() {
      $('form.settings-general-contact-form, form.settings-general-social-networks-form').on('change', '.switchery', function() {
        var $checkbox = $(this),
            $attributeItemWrapper = $checkbox.closest('.attribute-item-wrapper'),
            $urlContainer = $attributeItemWrapper.find('.url-container');

        if ($checkbox.is(':checked')) {
          $urlContainer.show();
          $urlContainer.find('input.input-destroy').val(false);
        } else {
          $urlContainer.hide();
          $urlContainer.find('input.input-destroy').val(true);
        }
      });
    },

    _initPhones: function() {
      function displayPhoneError($input, state) {
        if ($input.val() == "") return;

        if (state) {
          if (!$input.closest('.form-group').find('.validation-error-label').length) {
            $input.closest('.form-group').append('<p class="validation-error-label">Numéro incorrect</p>');
          }
        } else {
          $input.closest('.form-group').find('.validation-error-label').remove();
        }
      }

      $(".intl-tel-input").each(function() {
        var $this = $(this);
        $this.intlTelInput({
          initialCountry: $this.data('country-code'),
          separateDialCode: true,
          preferredCountries: ["fr"],
          formatOnDisplay: true,
          hiddenInput: $this.data('input-name'),
          utilsScript: "intlTelInput/utils.js"
        });

        displayPhoneError($this, !$this.intlTelInput('isValidNumber'));

        $this.on('change', function() {
          displayPhoneError($this, !$this.intlTelInput('isValidNumber'));
        });
      });
    },

    _initAddress: function() {
      var $section = $('[data-role="google-maps-address-section"]').first(),
          $btnChangeAddress = $section.find('.btn-change-address'),
          $inputGeocoder = $section.find('[data-role="find-address-input"]'),
          $map = $section.find('[data-role="address-map"]'),
          $summary = $section.find('[data-role="address-summary"]');

      var fieldBy = function(role) { return $section.find('[data-role="' + role + '"]').first(); };

      var setGmapHeight = function() {
        if ($map.length && $summary.length) {
          $map.css('height', $summary[0].offsetHeight + 'px');
        }
      };

      setGmapHeight();

      $btnChangeAddress.on('click', function() {
        $btnChangeAddress.closest('.form-group').find('.edit-address-fields').toggle().find('input').first().focus();
      });

      $section.find('[data-role="address-line-2"]').on('change', function() {
        $section.find('[data-address-component="line_2"]').html($(this).val());
      });

      $inputGeocoder.addresspicker({
        apiKey: helpers.google.api.key,
        elements: {
          map:          $map[0],
          lat:          fieldBy('address-latitude')[0],
          lng:          fieldBy('address-longitude')[0],
          postal_code:  fieldBy('address-postal-code')[0],
          locality:     fieldBy('address-city')[0],
          country:      fieldBy('address-country')[0],
          country_code: fieldBy('address-region-code')[0]
        },
        mapOptions: { zoom: 15 },
        draggableMarker: !$inputGeocoder.prop('disabled'),
        reverseGeocode: !$inputGeocoder.prop('disabled'),
        updateCallback: function(geocodeResult, parsedGeocodeResult) {
          var address_line_1 = [];
          if (parsedGeocodeResult.street_number) address_line_1.push(parsedGeocodeResult.street_number);
          if (parsedGeocodeResult.route) address_line_1.push(parsedGeocodeResult.route);

          fieldBy('address-line-1').val(address_line_1.join(' '));

          Object.keys(parsedGeocodeResult).forEach(function(key) {
            var $addressComponent = $section.find('[data-address-component=' + key + ']');
            if ($addressComponent.length) {
              $addressComponent.html(parsedGeocodeResult[key]);
            }
          });

          $(".intl-tel-input").each(function() {
            $(this).intlTelInput("setCountry", parsedGeocodeResult.country_code);
          });

          setGmapHeight();
        }
      });
    }
  });

  return GeneralController;

})(appCustomerSpace.Controllers.Settings.MainController);
